import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import { api } from "../../utils/apiClient";
import LoadingShimmer from "../../utils/LoadingShimmer";
import GlobalFilter from "../../components/filters/GlobalFilter";
import { showDeleteConfirm } from "../../utils/deleteConfirm";
import { toast } from "react-toastify";
import EventViewModal from "../../components/modal/EventViewModal";
import { Icon } from "@iconify/react/dist/iconify.js";
import ReadingPlanTable from "../../components/tables/ReadingPlanTable";
import ReadingPlanViewModal from "../../components/modal/ReadingPlanViewModal";




let searchTimeout;

const ReadingPlan = () => {
    const [readingPlan, setReadingPlan] = useState([]);
    const [loading, setLoading] = useState(true);

    //pagination
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    //sort
    const [sort, setSort] = useState("created_at");
    const [order, setOrder] = useState("desc");
    //search
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [dateFilters, setDateFilters] = useState({ startDate: "", endDate: "" });
    const [selectedDates, setSelectedDates] = useState([]);
    const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
    const navigate = useNavigate();
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedReadingPlan, setSelectedReadingPlan] = useState(null);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    //const [activeTab, setActiveTab] = useState("new");
    const [hundredDaysFilter, setHundredDaysFilter] = useState(null);
    const [nearbyToggle, setNearbyToggle] = useState(false);

    const handleView = (readingPlan) => {
        setSelectedReadingPlan(readingPlan);
        setViewModalOpen(true);
    };

    useEffect(() => {
        setDateFilters((prev) => ({
            ...prev,
            hundredDays: nearbyToggle ? "yes" : null
        }));

        setHundredDaysFilter(
            nearbyToggle ? { label: "Yes", value: "yes" } : null
        );

        setPage(1);
    }, [nearbyToggle]);

    useEffect(() => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            setDebouncedSearch(search);
            setPage(1);
        }, 1000);
        return () => clearTimeout(searchTimeout);
    }, [search]);

    const fetchReadingPlan = async () => {
        try {
            setLoading(true);

            const response = await api.get("/readingplan", {
                params: {
                    page,
                    limit: entriesPerPage,
                    sort,
                    order,
                    search: debouncedSearch?.trim() || "",
                    //status: activeTab,
                    startDate: dateFilters.startDate || undefined,
                    endDate: dateFilters.endDate || undefined,
                    hundredDays: dateFilters.hundredDays || undefined,
                }
            });

            // console.log("readingplan=======>", response.data)
            setReadingPlan(response.data.data || []);
            setTotalPages(response.data.pagination.totalPages || 1);
            setTotalEntries(response.data.pagination.total || 0);

        } catch (error) {
            console.error("Error fetching readingPlan:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReadingPlan();
    }, [page, entriesPerPage, sort, order, debouncedSearch, dateFilters]);


    const handleClearFilters = () => {
        setDateFilters({ startDate: "", endDate: "", hundredDays: null });
        setSelectedDates([]);
        setHundredDaysFilter(null); // ✅ reset dropdown UI
        setPage(1);
    };

    //date helper
    const formatLocalDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const handleDateFilter = ({ startDate, endDate, rawDates, hundredDays }) => {

        setSelectedDates(rawDates);

        const formattedStart = formatLocalDate(startDate);
        const formattedEnd = formatLocalDate(endDate);

        setDateFilters({
            startDate: formattedStart,
            endDate: formattedEnd,
            hundredDays: hundredDays || null, // ✅ now works
        });

        setPage(1);
    };

    const hundredDays = [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
    ];



    return (
        <>
            <div className="page-header-row">
                {/* Breadcrumb */}
                <Breadcrumb title="Reading Plan Management" />
                <div className="filter-wrapper">

                    <div className="d-flex align-items-center gap-3">
                        {/* Refresh Icon */}
                        <Icon
                            icon="mdi:refresh"
                            width="26"
                            height="26"
                            className={`ms-2 d-inline-flex d-md-none mobile-refresh-icon ${loading ? "spin" : ""}`}
                            onClick={fetchReadingPlan}
                        />
                        {/* Filter toggle button */}
                        <div className="filter-btn-wrapper">
                            <button
                                className="filter-btn"
                                onClick={() => setMobileFilterOpen(!mobileFilterOpen)}
                            >
                                {/* <Icon icon="mdi:filter" width="24" height="24" /> */}
                                <img src="assets\images\filter.png" alt="" className="filter-icon" />
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            {/* Filter panel (toggle on mobile, always visible on desktop) */}
            <div className={`filter-panel ${mobileFilterOpen ? "open" : ""}`}>
                <GlobalFilter
                    showDateRange={true}
                    onSearch={handleDateFilter}
                    onClear={handleClearFilters}
                    selectedDates={selectedDates}
                    showHundredUser={false}
                    hundredDaysOptions={hundredDays}
                    selectedHundredDays={hundredDaysFilter}
                    onHundredDaysChange={setHundredDaysFilter}
                />
            </div>

            {loading ? (
                < LoadingShimmer
                    columns={8}
                    rows={6}
                    avatarColumnIndex={2}
                    actionColumnIndex={7}
                />
            ) : (
                <ReadingPlanTable
                    readingplan={readingPlan}
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                    sort={sort}
                    order={order}
                    setSort={setSort}
                    setOrder={setOrder}
                    search={search}
                    setSearch={setSearch}
                    onView={handleView}
                    fetchReadingPlan={fetchReadingPlan}
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                    nearbyToggle={nearbyToggle}
                    setNearbyToggle={setNearbyToggle}
                />
            )}

            <ReadingPlanViewModal
                open={viewModalOpen}
                onClose={() => setViewModalOpen(false)}
                data={selectedReadingPlan}
            />
        </>
    );
};

export default ReadingPlan;
